export default {

  toActivity(url) {
    try {
      // eslint-disable-next-line no-undef
      JSBridge.toActivity(JSON.stringify(url));
    } catch (e) {
      // alert(e)
    }
  },

  webGetInteractionData() {
    try {
      // eslint-disable-next-line no-undef
      let x = JSBridge.webGetInteractionData();
      return JSON.parse(x);
    } catch (e) {
    }
  },
  onBackPressed(){
    try {
      // eslint-disable-next-line no-undef
      JSBridge.onBackPressed();
    } catch (e) {
      // alert(e)
    }
  },
  setUserName(userName) {
    try {
      // eslint-disable-next-line no-undef
      JSBridge.setUsername(userName);
    } catch (e) {
    }
  },
  setPassword(password) {
    try {
      // eslint-disable-next-line no-undef
      JSBridge.setPassword(password);
    } catch (e) {
    }
  },
  setSchoolInfo(schoolInfo) {
    try {
      // eslint-disable-next-line no-undef
      JSBridge.setSchoolInfo(schoolInfo);
    } catch (e) {
    }
  },
  getUserName() {
    try {
      // eslint-disable-next-line no-undef
      return JSBridge.getUsername();
    } catch (e) {
    }
    return "";
  },
  getPassword() {
    try {
      // eslint-disable-next-line no-undef
      return JSBridge.getPassword();
    } catch (e) {
    }
    return "";
  },
  getSchoolInfo() {
    try {
      // eslint-disable-next-line no-undef
      return JSBridge.getSchoolInfo();
    } catch (e) {
    }
    return "";
  },
};
